/*
 * @Author: zhangzhe 437050740@qq.com
 * @Date: 2023-09-14 17:34:39
 * @LastEditors: zhangzhe 437050740@qq.com
 * @LastEditTime: 2023-11-07 15:40:24
 * @FilePath: \smrjh:\web\guoxing_svn\trunk\webNew\src\network\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// const base = "http://8.217.216.114:81";
//  const base = "http://127.0.0.1";
const base = "http://47.104.180.77:81";
module.exports = base;